import { c } from 'react-compiler-runtime';
import styled, { css } from 'styled-components';
import { get } from '../../constants.js';
import sx from '../../sx.js';
import { jsxs, jsx } from 'react/jsx-runtime';

const StyledHeader = styled.div.withConfig({
  displayName: "Header__StyledHeader",
  componentId: "sc-cjezay-0"
})(["{}padding:6px ", ";font-size:", ";font-weight:", ";color:", ";", " ", ""], get('space.3'), get('fontSizes.0'), get('fontWeights.bold'), get('colors.fg.muted'), ({
  variant
}) => variant === 'filled' && css(["background:", ";margin:", " 0;border-top:1px solid ", ";border-bottom:1px solid ", ";&:first-child{margin-top:0;}"], get('colors.canvas.subtle'), get('space.2'), get('colors.neutral.muted'), get('colors.neutral.muted')), sx);

/**
 * Displays the name and description of a `Group`.
 */
function Header(t0) {
  const $ = c(12);
  let auxiliaryText;
  let props;
  let t1;
  let title;
  if ($[0] !== t0) {
    const {
      variant: t2,
      title: t3,
      auxiliaryText: t4,
      children: _children,
      ...t5
    } = t0;
    t1 = t2;
    title = t3;
    auxiliaryText = t4;
    props = t5;
    $[0] = t0;
    $[1] = auxiliaryText;
    $[2] = props;
    $[3] = t1;
    $[4] = title;
  } else {
    auxiliaryText = $[1];
    props = $[2];
    t1 = $[3];
    title = $[4];
  }
  const variant = t1 === undefined ? "subtle" : t1;
  let t2;
  if ($[5] !== auxiliaryText) {
    t2 = auxiliaryText && /*#__PURE__*/jsx("span", {
      children: auxiliaryText
    });
    $[5] = auxiliaryText;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== props || $[8] !== t2 || $[9] !== title || $[10] !== variant) {
    t3 = /*#__PURE__*/jsxs(StyledHeader, {
      role: "heading",
      variant: variant,
      ...props,
      children: [title, t2]
    });
    $[7] = props;
    $[8] = t2;
    $[9] = title;
    $[10] = variant;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}

export { Header, StyledHeader };
